<template>
<div class="page_map index pageSearch page_item bg">
    <div class="index_top">
        <div class="page-search">
            <van-row type="flex" justify="space-start">
                <van-col :span="1"></van-col>
                <van-col :span="20">
                    <van-cell-group class="search_field">
                        <form @submit.prevent="formSubmit" action="javascript:return true" > 
                            <van-field v-model="search_value" type="search" :placeholder="placeholder" style="color:#ffffff;" @keydown="searchDown($event)" ref="search" clearable autofocus @input="searchInput" >
                                <van-icon slot="right-icon" :name="righticon" @click="search"  />
                            </van-field>
                        </form>
                    </van-cell-group>
                </van-col>
                <van-col :span="3" class="search_ac" @click="search">搜索</van-col>
            </van-row>
        </div>
    </div>
    <!-- 分类 -->
    <div class="page">
        <van-tabs v-model="active" swipe-threshold="6" @change="changeTab">
            <van-tab title="非遗" :name="0" ></van-tab>
            <van-tab title="乡村振兴" :name="1"></van-tab>
            <van-tab title="红馆" :name="2" ></van-tab>
            <van-tab title="景区" :name="3" ></van-tab>
            <van-tab title="农特产品" :name="4" ></van-tab>
        </van-tabs>
    </div>
    <!-- 地图的搜索历史 -->
    <div class="search_fenlei" v-if="mapSearchRecord.length!=0&&showSearchRecord">
        <div class="search_title">历史记录</div>
        <ul class="search_list clearfix">
            <li :class="item.status ? 'search_item f-l slh_s active' : 'search_item f-l slh_s'" v-for="(item,index) in mapSearchRecord" :key="index" @click="searchRecordFun(item)">{{item.name}}</li>
        </ul>
    </div>
    <!-- 热门推荐 -->
    <div class="search_fenlei" v-if="recommendRecord.length!=0&&showSearchRecord">
        <div class="search_title">热门推荐</div>
        <ul class="search_list clearfix">
            <li :class="item.status ? 'search_item f-l slh_s active' : 'search_item f-l slh_s'" v-for="(item,index) in recommendRecord" :key="index" @click="searchRecordFun(item)">{{item.title}}</li>
        </ul>
    </div>
    <div class="no_data" v-if="showNoData">
        <img class="no_data_image" :src="publicPath + 'statics/images/search/no_data.png'" alt="" />
		<div class="no_data_title">暂无搜索结果</div>
        <div class="sepline" v-if="showNoRecommend"/>
        <div class="no_data_recommend" v-if="showNoRecommend">
            <div class="no_data_line"/>为您推荐<div class="no_data_line"/>
        </div>
    </div>
    <!-- 渲染列表 地图数据-->
    <van-list v-model="loading" :finished="finished" :finished-text="finishedText" @load="getMapData" v-if="dataList&&dataList.length>0">
        <div class="content" >
            <ul class="list">
                <li class="item clearfix" v-for="(item,index) in dataList" :key="index">
                    <div class="thumb f-l" @click="goItemInfo(item.id)" v-if="item.item">
						<van-image fit="contain" :show-loading="false" :src="item.item.thumb ? imageUrl+item.item.thumb : item.item_first_tu ? imageUrl+item.item_first_tu : $publicData.intangibleDefault" :error-icon="$publicData.intangibleDefault" />
                        <!-- <img :src="item.item.thumb ? item.item.thumb : $publicData.intangibleDefault" alt style="height:100%" /> -->
                    </div>
                    <div class="info f-l">
                        <div class="title clearfix" @click="goItemInfo(item.id)">
                            <span class="tag" v-if="item.item.level">「{{item.item.level.title}}」</span>
                            <span class="txt">{{item.title}}</span>
                        </div>
                        <div class="juli clearfix" @click="goItemInfo(item.id)">
                            <span class="f-l tag" v-if="item.item.cate">{{item.item.cate.name}}</span>
                            <span class="f-r num" v-if="item.distance>0">距离约 {{(item.distance/1000).toFixed(2)}}千米</span>
                        </div>
                        <div class="adress clearfix" @click="goItemInfo(item.id)">
                            <span class="f-l">地址：</span>
                            <div class="f-l detail">
                                <span v-if="item.item.area1">{{item.item.area1.areaname}}</span>
                                <span v-if="item.item.area2">{{'>'+item.item.area2.areaname+'>'}}</span>
                                <span v-if="item.item.area3">{{item.item.area3.areaname}}</span>
                            </div>
                        </div>
                        <div class="bottom clearfix">
                            <div class="action f-l" @click="goShop(item.tradesman_id)">店铺</div>
                            <div class="action f-l" @click="goSomeWhere(item.lng,item.lat,item.title)">去这里</div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </van-list>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;
export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            routeName: this.$route.query.routeName,
            active: parseInt(this.$route.query.type_id),
            placeholder: '请输入',
            search_value: '',
            righticon: process.env.BASE_URL + '/statics/images/search_ico.png',
            pages: {
                page: 1,
                size: 10
            },
            loading: false,
            finished: false,
            dataList: [],
            lng: localStorage.getItem('lng') ? localStorage.getItem('lng') : localStorage.getItem('lngDefault'),
            lat: localStorage.getItem('lat') ? localStorage.getItem('lat') : localStorage.getItem('latDefault'),
            finishedText: '', // 加载完成后的提示文案，默认是空，当加载完成时为'没有更多了'
            // unload: false, // 控制请求不同接口时，list组件 load方法自动加载
            mapSearchRecord: [], // 地图搜索历史
            recommendRecord: [], // 搜索推荐
            showSearchRecord: true,
            showNoData: false,
            showNoRecommend: false,
            hasItem: false, // 用于判断搜索记录是否有重复的名字
			token: '',
            publicPath: process.env.BASE_URL,
        }
    },
    created() {
        console.log(this.$route.query)
        // 根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '搜索'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token

                } else {
                    this.token = ''
                }
            })
            var params2 = {
                'data': {
                }
            }
            this.$bridge.callhandler('sdjy://public/getLocationInfo', params2, (data) => {
                console.log(111111111)
                console.log(data)
                if (data.code == 200) {
                    this.lat = data.result.latitude
                    this.lng = data.result.longitude
                } else {
                    this.lat = null
                    this.lng = null
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
        }
        // 判断是否 从地图相关页面进来
        
            
            this.mapSearchRecord = JSON.parse(localStorage.getItem('mapSearchRecord')) ? JSON.parse(localStorage.getItem('mapSearchRecord')) : []
            console.log('this.mapSearchRecord', this.mapSearchRecord)
        this.getHotData()
	},
    activated: function () {
        console.log('activated')
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            
        } else {
            // 获取列表
            if (this.goBack) { // 从后一页返回不刷新数据，从前一页进入刷新数据
                this.mapSearchRecord = JSON.parse(localStorage.getItem('mapSearchRecord')) ? JSON.parse(localStorage.getItem('mapSearchRecord')) : []
                console.log('this.mapSearchRecord', this.mapSearchRecord)
                this.pages = {
                    page: 1,
                    size: 10
                }
                this.search_value= ''
                this.showSearchRecord = true
                this.showNodata = false
                this.showNoRecommend = false
                this.allData= {
                    tradlist: [],
                    madelist: [],
                    livelist: [],
                    goodslist: [],
                    itemlist: []
                }
                this.loading= false
                this.finished= false
                this.dataList=[]
                
                this.finishedText= '' // 加载完成后的提示文案，默认是空，当加载完成时为'没有更多了'
                // unload: false, // 控制请求不同接口时，list组件 load方法自动加载
                this.getHotData()
            } 
            this.goBack = true
		}
    },
    methods: {
        formSubmit() {
            console.log('formSubmit')
            return false
        },
        searchInput(value) {
            console.log('value:',value)
            console.log('this.search_value:',this.search_value)
            if (this.search_value == null || this.search_value == undefined || this.search_value == '') {
                console.log('value:',111)
                this.showNoData = false;
                this.showNoRecommend = false
                this.showSearchRecord = true
                
                this.loading= false
                this.finished= false
                this.dataList=[]
                this.finishedText= '' // 加载完成后的提示文案，默认是空，当加载完成时为'没有更多了'
                // unload: false, // 控制请求不同接口时，list组件 load方法自动加载
                this.recommendRecord= []// 搜索推荐
                this.getHotData()
            }
        },
        searchDown(event) {
            if (event.code == 'Enter') {
                this.search()
            }
        },
        getHotData() {
            console.log('getHotData')
            var params = {
                token: this.token,
                type: 4
            }
            this.$api.index.searchHot(params).then(res => {
                if (res.code == 200) {
                    var typeList = res.result;
                    this.recommendRecord = typeList
                }
            })
        },
        // 获取地图数据
        getMapData() {
            // 不是地图
            var that = this
            if (!this.search_value) {
                this.finished = true
                return
            }
            console.log('加载地图数据')
            var params = {
                token: this.token,
                lng: this.lng,
                lat: this.lat,
                key: this.search_value,
                page: this.pages.page,
                size: this.pages.size
            }
            var arr = []
            arr.push(this.active)
            params.type_id = arr
            this.$api.map.searchItem(params).then(res => {
                console.log('res')
                if (res.code == 200) {
                    console.log('res')
                    console.log(res)
                    var list = res.result
                    for (var i in list) {
						// 无缩略图,取内容的第一张图片
						var content = list[i].item.content
						list[i].item_first_tu = this.imgUrlFun(content)
                        this.dataList.push(list[i])
                    }
                    if (list.length < this.pages.size || list.length == 0) {
                        // 数据加载完
                        this.finished = true
                        this.finishedText = '没有更多了'
                        // return
                    }
                    that.searchEnd(this.dataList.length<=0,false)
                } else {
                    // 接口出错
                    this.finished = true
                    // return
                }
                // 分页加载
                this.pages.page++
                this.loading = false
            })
        },
        searchEnd(showNodata,showNoRecommend) {
            console.log(showNodata)
            this.showSearchRecord = false
            this.showNoData = showNodata 
            this.showNoRecommend = showNoRecommend
        },
        // 搜索
        search() {
            if (!this.search_value) {
                return
            }
            console.log('search')
            // this.unload = false
            this.pages.page = 1
                this.dataList = []
                this.getMapData()
            // 地图搜索记录
            
                console.log('this.mapSearchRecord', this.mapSearchRecord)
                for (var i in this.mapSearchRecord) {
                    this.mapSearchRecord[i].status = 0
                    if (this.mapSearchRecord[i].name == this.search_value) {
                        this.hasItem = true
                        return
                    }
                }
                if (!this.hasItem) {
                    this.mapSearchRecord.unshift({
                        name: this.search_value,
                        status: 0
                    })
                }
                if (this.mapSearchRecord.length > 5) {
                    this.mapSearchRecord.pop()
                }
                localStorage.setItem('mapSearchRecord', JSON.stringify(this.mapSearchRecord));

            // 
        },
        // 查询 搜索记录
        searchRecordFun(item) {
            console.log('searchRecordFun')
            // item 是搜索记录
            var name = item.name
            if (item.name == null || item.name == undefined || item.name == '') {
                name = item.title
            }
            this.search_value = name
            this.pages.page = 1
           
                this.dataList = []
                for (var i in this.mapSearchRecord) {
                    if (this.mapSearchRecord[i].name == item.name) {
                        // item.status = 1
                    } else {
                        this.mapSearchRecord[i].status = 0
                    }
                }
                this.getMapData()

        },
        // 取消
        cancel() {
            this.search_value = ''
        },
        // 切换tab
        changeTab() {
            console.log('changeTab')
            this.pages.page = 1
            this.finishedText = ''
            this.dataList = []
            this.getMapData()
        },
        // 项目详情
        goItemInfo(id) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + '/item/detail?id=' + id
                    }
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    data => {}
                );
            } else {
                this.$router.push({
                    path: "/item/detail",
                    query: {
                        id: id
                    }
                });
                this.goBack = false
            }
        },
        // 去这里
        goSomeWhere(lng, lat, name) {
            console.log('window')
            console.log(window)
            window.location.href = '//uri.amap.com/marker?position=' + lng + ',' + lat + '&name=' + name
            this.goBack = false
        },
        // 去店铺
        goShop(id) {
            this.$router.push({
                path: '/art/detail',
                query: {
                    tradesmanId: id
                }
            })
            this.goBack = false
        },
        // 关联上键盘搜索，还需要测试ios
        show() {
            this.$refs.input1.blur();
		},
		// js富文本取第一张图片
        imgUrlFun: function(str) {
            var data = "";
            str.replace(/\<img [^>]*src=['"]([^'"]+)[^>]*\>/, function(
                match,
                capture
            ) {
				// console.log('match',match) // 匹配到的字符串
				// console.log('captrue',capture) // 匹配到的子串
                data = capture;
            });
            return data;
        }
    },
}
</script>

<style scoped>
/deep/ .page_item .list {
  padding-left: 0.001rem;
    display: flex;
}
/deep/ .van-image {
    width: 3.07rem;
    height: 3.07rem;
}
/deep/.van-row--justify-space-between {
    justify-content: flex-start;
}

/deep/.van-tabs__nav {
    display: block;
    white-space: nowrap;
    padding-left: .57rem;
}

/deep/.page .van-tab {
    display: inline-block;
    margin-right: 0.83rem;
    /* color: rgba(51, 51, 51, 1); */
}
/deep/.van-cell .van-field__control {
    color: white;
}
/deep/ input[type="search"]::-webkit-search-cancel-button {
	display: none;
} 
/deep/input::placeholder {
    color: #fff !important;
}
/deep/.page_iteminfo .jiangren .con{
	/* padding-left: 0; */
}
</style>
